export default [
  {
    width: 18,
    header: {
      type: 'text',
      caption: 'DealsID',
    },
    cell: {
      type: 'text',
      value: (e) => e.id,
      tooltip: true,
    },
  },
  {
    width: 18,
    header: {
      type: 'text',
      caption: 'Order',
    },
    cell: {
      type: 'text',
      value: (e) => e.orderId,
      tooltip: true,
    },
  },
  {
    width: 18,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'slot',
      name: 'type',
    },
  },
  {
    width: 25,
    header: {
      type: 'text',
      caption: 'Seller amount',
    },
    cell: {
      type: 'text',
      value: (e) => `${e.sellerAmount} ${e.sellerCurrency}`,
    },
  },
  {
    width: 25,
    header: {
      type: 'text',
      caption: 'Buyer amount',
    },
    cell: {
      type: 'text',
      value: (e) => `${e.buyerAmount} ${e.buyerCurrency}`,
    },
  },
  {
    width: 28,
    header: {
      type: 'text',
      caption: 'Seller name',
    },
    cell: {
      type: 'slot',
      name: 'seller',
    },
  },
  {
    width: 28,
    header: {
      type: 'text',
      caption: 'Buyer name',
    },
    cell: {
      type: 'slot',
      name: 'buyer',
    },
  },
  {
    width: 18,
    header: {
      type: 'text',
      caption: 'Status',
    },
    cell: {
      type: 'slot',
      name: 'status',
    },
  },
  {
    width: 16,
    header: {
      type: 'text',
      caption: 'Create date',
    },
    cell: {
      type: 'slot',
      name: 'createDate',
    },
  },
  {
    width: 16,
    header: {
      type: 'text',
      caption: 'Expiration date',
    },
    cell: {
      type: 'slot',
      name: 'expirationDate',
    },
  },
  {
    width: 40,
    header: {
      type: 'text',
      caption: 'Controls',
    },
    cell: {
      type: 'slot',
      name: 'controls',
    },
  },
];
